/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "orders": {
        "nested": {
          "search": {
            "nested": {
              "opt": {
                "nested": {
                  "BackendSpecificStringOption": {
                    "fields": {
                      "payplatGraph": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "salesGraph": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "BackendSpecificRepeatedStringOption": {
                    "fields": {
                      "payplatGraph": {
                        "type": "string",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "salesGraph": {
                        "type": "string",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  },
                  "ExcludedSearchField": {
                    "fields": {
                      "searchField": {
                        "type": ".squareup.orders.search.opt.BackendSpecificStringOption",
                        "id": 1,
                        "rule": "optional"
                      },
                      "value": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "OrdersSearchFeature": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "ALLOW_TEST": 1,
                      "ALLOW_M05_FEATURES": 2,
                      "ALLOW_M1_FEATURES": 3,
                      "ALLOW_M2_FEATURES": 4,
                      "ALLOW_MX_FEATURES": 5
                    }
                  },
                  "OrdersSearchFeatures": {
                    "fields": {
                      "features": {
                        "type": ".squareup.orders.search.opt.OrdersSearchFeature",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "OrdersSearchMatchedAttribute": {
                    "values": {
                      "UNKNOWN_MATCHED_ATTRIBUTE": 0,
                      "ORDER_REFERENCE_ID": 1,
                      "ORDER_NAME": 2,
                      "TICKET_NAME": 3,
                      "NOTES": 4,
                      "CATALOG_ITEM_NAME": 5,
                      "CATALOG_VARIATION_NAME": 6,
                      "CATALOG_CATEGORY_NAME": 7,
                      "CATALOG_MODIFIER_NAME": 8,
                      "EMPLOYEE_NAME": 9,
                      "FULFILLMENT_TRACKING_NUMBER": 10,
                      "CUSTOMER_NAME": 11,
                      "CUSTOMER_EMAIL": 12,
                      "CUSTOMER_PHONE_NUMBER": 13,
                      "CUSTOMER_ADDRESS_LOCALITY": 14,
                      "CUSTOMER_ADDRESS_POSTAL_CODE": 15,
                      "FULFILLMENT_TABLE_NAME": 16,
                      "FULFILLMENT_SECTION_NAME": 17,
                      "FULFILLMENT_ASSIGNED_IDENTIFIER": 18,
                      "CARD_LAST_FOUR": 19,
                      "RECEIPT_NUMBER": 20,
                      "ORDER_SOURCE_NAME": 21,
                      "LINE_ITEM_GROUP_CATALOG_NAME": 22
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.orders?.nested?.search?.nested?.opt?.nested?.BackendSpecificStringOption && !$root.nested?.squareup?.nested?.orders?.nested?.search?.nested?.opt?.nested?.BackendSpecificRepeatedStringOption && !$root.nested?.squareup?.nested?.orders?.nested?.search?.nested?.opt?.nested?.ExcludedSearchField && !$root.nested?.squareup?.nested?.orders?.nested?.search?.nested?.opt?.nested?.OrdersSearchFeature && !$root.nested?.squareup?.nested?.orders?.nested?.search?.nested?.opt?.nested?.OrdersSearchFeatures && !$root.nested?.squareup?.nested?.orders?.nested?.search?.nested?.opt?.nested?.OrdersSearchMatchedAttribute) {
  $root.addJSON(jsonData);
}

/**
 * Type that can be used in place of a string option when the option values need to vary per backend.
 *
 * SOURCE BackendSpecificStringOption @ squareup/orders/search/opt/options.proto at 9:1
 */
export const BackendSpecificStringOption = $root.lookupType('squareup.orders.search.opt.BackendSpecificStringOption');
fixType(BackendSpecificStringOption);
Builder.createAndAttachToType(BackendSpecificStringOption);
/**
 * Type that can be used in place of a repeated string option when the option values need to vary per backend.
 *
 * SOURCE BackendSpecificRepeatedStringOption @ squareup/orders/search/opt/options.proto at 15:1
 */
export const BackendSpecificRepeatedStringOption = $root.lookupType('squareup.orders.search.opt.BackendSpecificRepeatedStringOption');
fixType(BackendSpecificRepeatedStringOption);
Builder.createAndAttachToType(BackendSpecificRepeatedStringOption);
/**
 * Definition for excluded search fields, allowing for static declaration of the field for the
 * excluded value and the value being excluded.
 *
 * SOURCE ExcludedSearchField @ squareup/orders/search/opt/options.proto at 171:1
 */
export const ExcludedSearchField = $root.lookupType('squareup.orders.search.opt.ExcludedSearchField');
fixType(ExcludedSearchField);
Builder.createAndAttachToType(ExcludedSearchField);
/**
 * The list of current features.
 *
 * SOURCE OrdersSearchFeature @ squareup/orders/search/opt/options.proto at 177:1
 */
export const OrdersSearchFeature = $root.lookupEnum('squareup.orders.search.opt.OrdersSearchFeature').values;
/**
 * SOURCE OrdersSearchFeatures @ squareup/orders/search/opt/options.proto at 192:1
 */
export const OrdersSearchFeatures = $root.lookupType('squareup.orders.search.opt.OrdersSearchFeatures');
fixType(OrdersSearchFeatures);
Builder.createAndAttachToType(OrdersSearchFeatures);
/**
 * SOURCE OrdersSearchMatchedAttribute @ squareup/orders/search/opt/options.proto at 196:1
 */
export const OrdersSearchMatchedAttribute = $root.lookupEnum('squareup.orders.search.opt.OrdersSearchMatchedAttribute').values;